module.exports = __webpack_public_path__ + "img/img_1.e53da3f8.png";